import * as yup from 'yup';

export const ambulantOptionenSchema = yup.object({
  ergaenzungGKV: yup.string().default(''),
  gebuehrenordnung: yup.string().default(''),
  heilpraktiker: yup.boolean().default(false),
  kurort: yup.boolean().default(false),
  logopaedie: yup.boolean().default(false),
  ergotherapie: yup.boolean().default(false),
  hilfsmittel: yup.boolean().default(false),
});
